<script setup lang="ts">
import { useRouter } from 'vue-router'

interface Props {
  consultingLink: string
  introductionLink: string
  notLoginNotBuy: string
}

defineProps<Props>()

const router = useRouter()

function goLogin() {
  router.push(router.resolve({ path: '/sign' }))
}

function goIndex() {
  router.push(router.resolve({ path: '/' }))
}
</script>

<template>
  <div class="authority d-flex align-items-center text-center">
    <div class="aut-btn m-auto">
      <p v-if="notLoginNotBuy === 'login'">
        {{ $t('product_list_alert_login') }}
      </p>
      <p v-else>
        {{ $t('product_list_alert_content') }}
      </p>
      <button
        v-if="notLoginNotBuy === 'login'"
        class="btn btn-primary btn-white"
        @click="goLogin()"
      >
        {{ $t('product_list_alert_ask') }}
      </button>
      <button v-else class="btn btn-primary btn-white" @click="goIndex()">
        {{ $t('product_list_alert_goback') }}
      </button>
      <a target="_blank" :href="introductionLink">
        <button class="btn btn-primary btn-white">
          {{ $t('product_list_alert_info') }}
        </button>
      </a>
    </div>
  </div>
</template>
